export interface FaqItem {
  q: string;
  a: string;
}

export const faqs: FaqItem[] = [
  {
    q: "51吃瓜榜 的热度排名是怎么产生的？",
    a: "我们综合话题在公开平台的讨论量、转发增速与持续时长计算热度值，并按实时数据动态调整名次，所以榜单会随着围观热度不断变化。",
  },
  {
    q: "榜单多久更新一次？",
    a: "热门吃瓜榜 采用滚动更新。热度变化较快的话题通常十几分钟就会有新的名次，顶部话题会出现“实时”标记，方便你优先查看正在发酵的焦点。",
  },
  {
    q: "可以只看某一类话题吗？",
    a: "可以。首页提供分类切换，包含全网热榜、娱乐圈、影视综艺、网红达人、社会热议与生活杂谈，选择分类后榜单会立即筛选出对应内容。",
  },
  {
    q: "为什么有的条目显示“新上榜”？",
    a: "“新上榜”代表该话题是本次统计周期内第一次进入榜单。这类话题往往刚被大量围观，热度还在爬升阶段，值得优先看一眼。",
  },
  {
    q: "网站会保存我的浏览记录吗？",
    a: "当前版本为纯内容浏览站，不需要登录，也不收集个人身份信息。你可以在不注册的情况下查看全部榜单与话题详情。",
  },
  {
    q: "如果我发现某条内容有误怎么办？",
    a: "欢迎通过联系我们栏目反馈。我们会核实相关内容，并在确认后及时修正或调整展示，保证榜单聚焦在真实、可讨论的焦点事件上。",
  },
];